import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useRef } from "react";
import { useInView } from "../../hooks/useInView";

const BannerFund2 = () => {
  const bannerFund2Ref = useRef(null);

  const isInView = useInView(bannerFund2Ref);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "SITE: Click - Nova página de conteúdo - banner escola das adolescências - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "SITE: Click - Nova página de conteúdo - banner escola das adolescências - bloco visualizado",
      });
    }
  }, [isInView]);

  function sendEvent () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "cta_click",
      label:
        "SITE: Click - Nova página de conteúdo - banner escola das adolescências - clique no botão",
    });
  }

  return (
    <div className="theme-block eva-card eva-bg-inst-50 eva-mb-06">
      <div className="eva-card-info">
        <Typography variant="title" size={6} asChild className="eva-mb-04">
          <p ref={bannerFund2Ref}>
            <i className="fa-regular fa-star eva-mr-03 eva-body-2"></i>
            Curso: Adolescências - Da neurociência à sala de aula
          </p>
        </Typography>
        <StaticImage
          src="https://s3.amazonaws.com/lms.novaescola.org.br/imagens/e9d3edb0-6bce-11ef-ae6a-bd4a78d7e89a.png"
          alt=""
          width={328}
          height={184}
          className="eva-mb-06"
        />
        <Typography variant="body" size={2} className="eva-mb-06">
        Descubra como engajar estudantes nos Anos Finais em nosso curso online e gratuito.
        </Typography>
        <Button variant="outline-primary" size="medium" asChild>
          <a
            type="button"
            className="eva-btn-full eva-mt-02"
            href="https://cursos.novaescola.org.br/curso/12133/adolescencias-da-neurociencia-a-sala-de-aula/resumo"
            onClick={sendEvent}
          >
            Saiba mais
          </a>
        </Button>
      </div>
    </div>
  );
};

export default BannerFund2;
